/**
 * Care schemas
 */

import { z } from 'zod';
import { pillarScoreSchema } from '../validators';

/**
 * Daily check-in schema
 */
export const dailyCheckinSchema = z.object({
  moodScore: z.number().int().min(1).max(5),
  notes: z.string().max(500).optional(),
});

/**
 * Checkpoint response schema
 */
export const checkpointResponseSchema = z.object({
  checkpointId: z.uuid(),

  // Pillar scores
  housingScore: pillarScoreSchema.optional(),
  schoolingScore: pillarScoreSchema.optional(),
  workScore: pillarScoreSchema.optional(),
  wellbeingScore: pillarScoreSchema.optional(),

  // Extended scores (Business)
  extendedScores: z
    .object({
      productivity: pillarScoreSchema.optional(),
      engagement: pillarScoreSchema.optional(),
      satisfaction: pillarScoreSchema.optional(),
      retentionRisk: pillarScoreSchema.optional(),
      teamIntegration: pillarScoreSchema.optional(),
      skillDevelopment: pillarScoreSchema.optional(),
      cultureFit: pillarScoreSchema.optional(),
      careerProgress: pillarScoreSchema.optional(),
    })
    .optional(),

  // Additional responses
  responses: z.record(z.string(), z.unknown()).optional(),
});

/**
 * Support request schema
 */
export const supportRequestSchema = z.object({
  type: z.enum([
    'support_call',
    'housing_assistance',
    'admin_support',
    'language_support',
    'wellbeing_check',
    'emergency',
    'custom',
  ]),
  priority: z.enum(['low', 'medium', 'high', 'urgent']).default('medium'),
  title: z.string().min(1).max(255),
  description: z.string().max(2000).optional(),
});

// Type exports
export type DailyCheckinInput = z.infer<typeof dailyCheckinSchema>;
export type CheckpointResponseInput = z.infer<typeof checkpointResponseSchema>;
export type SupportRequestInput = z.infer<typeof supportRequestSchema>;
